import * as React from 'react';
import { useSelector } from 'react-redux';

import { Mortgage } from '../../components/Mortgage';
import { selectMortgage } from '../../selectors/promosPage';

export const MortgageContainer = () => {
  const mortgageInfo = useSelector(selectMortgage);

  const banksMoreCount = mortgageInfo.allBanksCount - mortgageInfo.banksLogo.length;

  return (
    <Mortgage
      banksLogo={mortgageInfo.banksLogo}
      banksMoreCount={banksMoreCount}
      buttonText={mortgageInfo.buttonText}
      description={mortgageInfo.description}
      url="/ipoteka-main/?banner=newbuilding-promos"
    />
  );
};
